import useSWR from 'swr';
import type { IMfaStatusView } from '@shared/services';
import { getMfaStatus } from '../requests';

/** The SWR cache key for the account's MFA status; also the endpoint the fetcher hits. */
export const MFA_STATUS_KEY = '/api/v1/auth/mfa/status';

/**
 * Loads the signed-in account's MFA status over the session-authorized `authApi`. Exposes `mutate`
 * so the passkey add/remove flows can revalidate the list in place — no full page reload.
 */
export const useMfaStatus = () => {
  const { data, error, isLoading, mutate } = useSWR<IMfaStatusView>(MFA_STATUS_KEY, getMfaStatus);

  return { status: data, isLoading, error, mutate };
};
